import type {RequestFailureReason} from '../types/request';

import {RequestFailureLogMessageProps} from './types';

/**
 * Classifies the root cause of a fetch failure for structured logging.
 * - `timeout`: AbortSignal.timeout() fired (DOMException with name TimeoutError)
 * - `abort`: explicit AbortController.abort() — component unmount, navigation, etc.
 * - `network`: connection lost, DNS failure, CORS block (TypeError from fetch)
 * - `unknown`: anything else
 */
export function classifyRequestFailure(error: unknown): RequestFailureReason {
  if (error instanceof DOMException && error.name === 'TimeoutError')
    return 'timeout';

  if (error instanceof DOMException && error.name === 'AbortError')
    return 'abort';

  if (error instanceof TypeError) return 'network';

  return 'unknown';
}

// This function is used to build the log message for a request failure.
export function buildRequestFailureLogMessage({
  baseMessage,
  method,
  requestUrl,
  resolvedRequest,
  status,
}: RequestFailureLogMessageProps): string {
  const endpoint = resolvedRequest.logicalPath || requestUrl.pathname;
  const statusPrefix = typeof status === 'number' ? `${status} ` : '';

  return `${baseMessage} [${statusPrefix}${method} ${endpoint}]`;
}
